export const optimization = [
  {
    id: '0',
    name: '无',
    media: 10
  },
  {
    id: '1',
    name: '激活',
    media: 10
  },
  {
    id: '2',
    name: '注册',
    media: 10
  },
  {
    id: '5',
    name: '付费',
    media: 10
  },
  {
    id: '6',
    name: '次留',
    media: 10
  },
  {
    id: '15',
    name: '直播间观看',
    media: 10
  },
  {
    id: '16',
    name: '直播间停留',
    media: 10
  },
  {
    id: '17',
    name: '直播间内打赏',
    media: 10
  },
  {
    id: '18',
    name: '账号关注',
    media: 10
  },
  {
    id: '19',
    name: '组件点击',
    media: 10
  },
  {
    id: '20',
    name: '粉丝入群',
    media: 10
  },
  {
    id: '21',
    name: '表单预约',
    media: 10
  },
  {
    id: '22',
    name: '预约下载',
    media: 10
  },
  {
    id: '23',
    name: '关键行为',
    media: 10
  },
  {
    id: '0',
    name: '无',
    media: 16
  },
  {
    id: '1',
    name: '激活',
    media: 16
  },
  {
    id: '2',
    name: '注册',
    media: 16
  },
  {
    id: '4',
    name: '首次付费',
    media: 16
  },
  {
    id: '6',
    name: '次留',
    media: 16
  },
  {
    id: '12',
    name: '付费次数',
    media: 16
  },
  {
    id: '13',
    name: '下单',
    media: 16
  },
  {
    id: '21',
    name: '表单预约',
    media: 16
  },
  {
    id: '22',
    name: '预约下载',
    media: 16
  },
  {
    id: '0',
    name: '无',
    media: 32
  },
  {
    id: '1',
    name: '激活',
    media: 32
  },
  {
    id: '2',
    name: '注册',
    media: 32
  },
  {
    id: '5',
    name: '付费',
    media: 32
  },
  {
    id: '3',
    name: '行为数',
    media: 32
  },
  {
    id: '7',
    name: '首日ROI',
    media: 32
  },
  {
    id: '11',
    name: '七日ROI',
    media: 32
  },
  {
    id: '14',
    name: '七日付费次数',
    media: 32
  },
  {
    id: '21',
    name: '表单预约',
    media: 32
  },
  {
    id: '22',
    name: '预约跳转点击',
    media: 32
  },
  {
    id: '0',
    name: '无',
    media: 45
  },
  {
    id: '1',
    name: '激活',
    media: 45
  },
  {
    id: '2',
    name: '注册',
    media: 45
  },
  {
    id: '5',
    name: '付费',
    media: 45
  }
]

export const deepOptimization = [
  {
    id: '0',
    name: '无',
    media: 10
  },
  {
    id: '7',
    name: 'ROI系数',
    media: 10
  },
  {
    id: '8',
    name: '每次付费',
    media: 10
  },
  {
    id: '9',
    name: '双出价',
    media: 10
  },
  {
    id: '10',
    name: 'ROI自动优化',
    media: 10
  },
  {
    id: '14',
    name: '首日ROI+7日ROI',
    media: 10
  },
  {
    id: '15',
    name: '每次付费+7日ROI',
    media: 10
  },
  {
    id: '25',
    name: '变现ROI',
    media: 10
  },
  {
    id: '26',
    name: '变现ROI-7日',
    media: 10
  },
  {
    id: '27',
    name: '付费ROI-30日',
    media: 10
  },
  {
    id: '0',
    name: '无',
    media: 16
  },
  {
    id: '2',
    name: '注册',
    media: 16
  },
  {
    id: '4',
    name: '首次付费',
    media: 16
  },
  {
    id: '6',
    name: '次留',
    media: 16
  },
  {
    id: '7',
    name: '首日付费ROI',
    media: 16
  },
  {
    id: '11',
    name: '七日付费ROI',
    media: 16
  },
  {
    id: '12',
    name: '付费次数',
    media: 16
  },
  {
    id: '13',
    name: '下单',
    media: 16
  },
  {
    id: '0',
    name: '无',
    media: 32
  },
  {
    id: '6',
    name: '次留',
    media: 32
  },
  {
    id: '5',
    name: '付费',
    media: 32
  },
  {
    id: '7',
    name: '付费ROI',
    media: 32
  },
  {
    id: '0',
    name: '无',
    media: 45
  },
  {
    id: '2',
    name: '注册',
    media: 45
  },
  {
    id: '5',
    name: '付费',
    media: 45
  },
  {
    id: '7',
    name: '付费ROI',
    media: 45
  },
  {
    id: '24',
    name: '小游戏-30日付费ROI',
    media: 16
  },
  {
    id: '28',
    name: '首日变现ROI',
    media: 16
  },
  {
    id: '29',
    name: '七日变现ROI',
    media: 16
  },
  {
    id: '30',
    name: '30天变现ROI',
    media: 16
  }
]

export const ADDITION_ENUM = {
  RANGE: 3,
  EQUAL: 4,
  LESS: 2,
  GREATER: 1
}
export const ADDITION_FILTER_CONDITIONS = [
  {
    label: '大于等于',
    value: ADDITION_ENUM.GREATER
  },
  {
    label: '小于等于',
    value: ADDITION_ENUM.LESS
  },
  {
    label: '介于',
    value: ADDITION_ENUM.RANGE
  }
]

export const additionFilterFormItems = [
  {
    label: '项目/组预算',
    unit: '元',
    prop: 'projectDayBudget',
    conditions: [{ label: '等于', value: ADDITION_ENUM.EQUAL }, ...ADDITION_FILTER_CONDITIONS]
  },
  { label: '项目/组目标出价', unit: '元', prop: 'projectTargetBid', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '项目/组深度目标出价', unit: '元', prop: 'projectDeepBid', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '项目/组ROI出价', unit: '元', prop: 'projectRoi', conditions: ADDITION_FILTER_CONDITIONS },
  {
    label: '计划预算',
    unit: '元',
    prop: 'adBudget',
    conditions: [{ label: '等于', value: ADDITION_ENUM.EQUAL }, ...ADDITION_FILTER_CONDITIONS]
  },
  { label: '计划目标出价', unit: '元', prop: 'bid', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '计划深度目标出价', unit: '元', prop: 'deepCpabid', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '计划ROI出价', unit: '元', prop: 'roiRatio', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '账面消耗', unit: '元', prop: 'paperUseAmount', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '创角成本', unit: '元', prop: 'createRoleCost', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '新创角付费金额', unit: '元', prop: 'newRoleMoney', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '新创角回款率', unit: '%', prop: 'newRoleRate', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '新创角24小时ROI', unit: '%', prop: 'createRole24hRoi', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '每次付费成本', unit: '元', prop: 'newRolePayCntCost', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '付费成本', unit: '元', prop: 'newPayCost', conditions: ADDITION_FILTER_CONDITIONS },
  { label: '总流水', unit: '元', prop: 'sumMoney', conditions: ADDITION_FILTER_CONDITIONS }
]

/**
 * @description: 头条起量素材类型
 * @return {*}
 */
export const TOUTIAO_RAISE_MATERIAL_TYPE = {
  SPECIFIED: 'SPECIFIED',
  ALL: 'ALL'
}

/**
 * @description: 头条起量抽屉展示类型
 * @return {*}
 */
export const TOUTIAO_RAISE_DRAWER_TYPE = {
  NONE: -1,
  CREATE: 1,
  DETAIL: 2,
  REPORT: 3
}
